export const defaultTheme = {
  main: "#006276",
  second: "#9DCF56",
  third: "#241F20",
  mainText: "white",
  name: "Likewatt",
};
